<!--
Program: Modal Dialog
Author: SDL
Description: Dialog Common Component
-->
<template>
    <modal
        name="dialog"
        height="auto"
        :classes="['v--modal', 'vue-dialog', 'modal-mask']"
        :width="width"
        :pivot-y="0.3"
        :adaptive="true"
        :clickToClose="clickToClose"
        :transition="transition"
        @before-open="beforeOpened"
        @before-close="beforeClosed"
        @opened="$emit('opened', $event)"
        @closed="$emit('closed', $event)"
    >
        <div class="modal-wrapper">
            <div class="modal_size" :class="[this.params.class]">
                <dl class="modal_content alert_msg">
                    <dt class="ellipsis">
                        <h5 name="header" v-if="params.title" v-html="params.title || ''" />
                    </dt>
                    <component v-if="params.component" v-bind="params.props" :is="params.component"> </component>
                    <dd v-else v-html="params.text || ''"></dd>
                </dl>

                <div class="btn_modal_wrap" v-if="buttons" :class="buttons.length === 2 ? 'set_2' : ''">
                    <div class="btn_right">
                        <a
                            href="javascript:"
                            type="button"
                            v-for="(button, i) in buttons"
                            :class="button.default ? 'btn_white' : 'btn_blue'"
                            :key="i"
                            v-html="button.title"
                            @click.stop="click(i, $event)"
                        >
                            {{ button.title }}
                        </a>
                    </div>
                </div>
                <div v-else class="vue-dialog-buttons-none"></div>
                <a href="javascript:" class="ui_close" type="button" @click="closeClick($event)"><span class="sr_only">popup close</span></a>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    name: 'VueJsDialog',
    props: {
        width: {
            type: [Number, String],
            default: 400,
        },
        clickToClose: {
            type: Boolean,
            default: true,
        },
        transition: {
            type: String,
            default: 'fade',
        },
    },
    data() {
        return {
            params: {},
            defaultButtons: [{ title: 'CLOSE' }],
        };
    },
    computed: {
        buttons() {
            return this.params.buttons || this.defaultButtons;
        },
        /**
         * Returns FLEX style with correct width for arbitrary number of
         * buttons.
         */
        buttonStyle() {
            return {
                flex: `1 1 ${100 / this.buttons.length}%`,
            };
        },
    },
    methods: {
        /**
         * param: event
         * return:
         * exception:
         * Description : Run Event before Modal opening
         */
        beforeOpened(event) {
            window.addEventListener('keyup', this.onKeyUp);

            this.params = event.params || {};
            this.$emit('before-opened', event);
        },
        /**
         * param: event
         * return:
         * exception:
         * Description : Run Event before Modal closing
         */
        beforeClosed(event) {
            window.removeEventListener('keyup', this.onKeyUp);

            this.params = {};
            this.$emit('before-closed', event);
        },
        /**
         * param: i -> button index
         * param: event
         * param: source -> String
         * return:
         * exception:
         * Description : Run Event Button Click
         */
        click(i, event, source = 'click') {
            const button = this.buttons[i];

            if (button && typeof button.handler === 'function') {
                button.handler(i, event, { source });
            } else {
                this.$modal.hide('dialog');
            }
        },
        /**
         * param: event
         * param: source -> String
         * return:
         * exception:
         * Description : Run Event Close Button Click
         */
        closeClick(event, source = 'click') {
            const button = this.buttons[0];

            if (button && typeof button.handler === 'function') {
                button.handler(0, event, { source });
            }
            this.$modal.hide('dialog');
        },
        /**
         * param: event
         * return:
         * exception:
         * Description : Run Event Key Up
         */
        onKeyUp(event) {
            if (event.which === 13 && this.buttons.length > 0) {
                const buttonIndex = this.buttons.length === 1 ? 0 : this.buttons.findIndex(button => button.default);

                if (buttonIndex !== -1) {
                    this.click(buttonIndex, event, 'keypress');
                }
            }
        },
    },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/common/control/modal/Dialog.vue